import {Repository} from "../../persistence/repository";
import {IssueType} from "../entities/issue-type.entity";
import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {QueryParameter} from "../../connectivity/query-parameter.interface";
import {IssueTypeDTO} from "../dtos/issue-type.dto";
// import {ValueOf} from "../../types/value-of.type";

// type IssueTypeDto = {
//   include: string,
//   shortcut: string,
//   cssClasses: string,
//   description: string,
//   showInHeader: boolean
// }

@singleton()
@persistence({
    entity: IssueType,
    preload: true
})
export class IssueTypeRepository extends Repository<IssueType> {

    public create(): Promise<IssueType | null> {
        return Promise.resolve(new IssueType());
    }

    /**
     * Reads canMoveRoot and canDelete of one type again and writes them onto the instance in use.
     * They change while the type list stays loaded (an issue gets the type, its last issue is
     * deleted); the instance is kept so the combobox and the row menu keep their object identity.
     */
    public async refreshPermissions(issueType: IssueType): Promise<void> {
        const results = await this.entityManager.query<IssueTypeDTO>(
            `IssueType`,
            [{key: `uid`, comparator: `eq`, value: issueType.uid} as QueryParameter<IssueTypeDTO>],
            0,
            1,
            [],
            [`permissions`],
            {includeDeleted: true}
        );
        const dto = results?.[0];
        if (!dto) {
            return;
        }
        issueType.canMoveRoot = dto.canMoveRoot ?? null;
        issueType.canDelete = dto.canDelete ?? null;
    }

    // private readonly _items: Map<string, IssueType> = new Map<string, IssueType>();
    //
    // private readonly _values: IssueTypeDto[] = [{
    //     include: "konzeptkick",
    //     shortcut: "KK",
    //     cssClasses: "besprechung",
    //     description: "KonzeptKickOff",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "schulter",
    //     shortcut: "SB",
    //     cssClasses: "besprechung",
    //     description: "Schulterblick",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "kick",
    //     shortcut: "K",
    //     cssClasses: "besprechung",
    //     description: "KickOff",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "standabnahme",
    //     shortcut: "SA",
    //     cssClasses: "standabnahme",
    //     description: "Standabnahme",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "medienabnahme",
    //     shortcut: "MA",
    //     cssClasses: "besprechung",
    //     description: "Medienabnahme",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "medienkick",
    //     shortcut: "M",
    //     cssClasses: "besprechung",
    //     description: "MedienKickOff",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "archit",
    //     shortcut: "AR",
    //     cssClasses: "architektur",
    //     description: "Architektur",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "bestellung",
    //     shortcut: "B",
    //     cssClasses: "architektur",
    //     description: "Technische Bestellungen",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "social",
    //     shortcut: "S",
    //     cssClasses: "social",
    //     description: "Social Media Inhalte",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "touch",
    //     shortcut: "T",
    //     cssClasses: "touch",
    //     description: "Touchpanel",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "versand",
    //     shortcut: "V",
    //     cssClasses: "versand",
    //     description: "Versand",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "grafikdaten",
    //     shortcut: "G",
    //     cssClasses: "grafik",
    //     description: "Grafikdaten",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "micro",
    //     shortcut: "M",
    //     cssClasses: "microsite",
    //     description: "Microsite",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "film",
    //     shortcut: "F",
    //     cssClasses: "film",
    //     description: "Film",
    //     showInHeader: true,
    //   },
    //   {
    //     include: "review",
    //     shortcut: "RV",
    //     cssClasses: "besprechung",
    //     description: "Review",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "jourfix",
    //     shortcut: 'JF',
    //     cssClasses: "besprechung",
    //     description: "Jourfix",
    //     showInHeader: false,
    //   },
    //   {
    //     include: "zeit",
    //     shortcut: 'ZT',
    //     cssClasses: "arbeitszeit",
    //     description: "zeit",
    //     showInHeader: false,
    //   }, {
    //     include: "unknown",
    //     shortcut: "?",
    //     cssClasses: "unknown",
    //     description: "Unbekannte Art des Termins",
    //     showInHeader: false
    //   }]

    // constructor() {
    //   super();
    //   for (const issueTypeDto of this._values) {
    //     this._items.set(issueTypeDto.description.toLocaleUpperCase(), Object.assign((new IssueType()), issueTypeDto))
    //   }
    // }
    //
    //
    // public async findOneBy(fieldName: keyof IssueType, value: ValueOf<IssueType>): Promise<IssueType | null> {
    //   return Promise.resolve(Array.from(this._items.values()).find(issueType => issueType[fieldName] === value) ?? null);
    // }
}